import React, { Component } from "react";
import "../sass/Banner.scss";

export default class Banner extends Component {
  render() {
    return <div className="banner" role="img" aria-label="Maddlynn's eyes" />;
  }
}
